import React from 'react'
import { Student } from './Student'
import {
	getStudents,
	type StudentWithPoints,
} from '@mission.io/mission-toolkit'
import { useMissionStateSelector } from '../../../context'
import { values } from '../../../utility'

export default function JrStudentView(): React$Node {
	const students = useMissionStateSelector(state => getStudents(state, true))
	let presentStudents: StudentWithPoints[] = students
		? values(students)
				.filter(student => {
					const studentType = ((student: any): StudentWithPoints)
					return !studentType.absent
				})
				.sort((a: StudentWithPoints, b: StudentWithPoints) => {
					if (a.firstName < b.firstName) {
						return -1
					} else if (a.firstName > b.firstName) {
						return 1
					} else {
						return 0
					}
				})
		: []
	return (
		<div className="flex-1 overflow-y-auto mb-4 mt-12 login-scrollbar">
			<div className="flex flex-wrap justify-center w-full text-base">
				{presentStudents.map(student => (
					<Student
						key={student.id}
						student={student}
						className={'p-3 mx-4 mt-2 w-[17%]'}
					/>
				))}
			</div>
		</div>
	)
}
